import React from "react";
import { TemplatesPageTitleStyled } from "./styled";
import { Icon, Typography, Button } from "antd";
//import SearchTemplateBar from "./SearchTemplateBar/SearchTemplateBar";
import {  observer } from "mobx-react";
//import ViewStore from "../../../stores/ViewStore";

const Title = 
  observer(
    ({
      showAddButton,
    }: {
      showAddButton: boolean;
    }) => {
      const { Title } = Typography;
      return (
        <div>
          <Title level={3}>Templates Library</Title>
          {showAddButton && (
            <Button
              type="primary"
              onClick={() => {}}
            >
              <Icon type="plus" />
              New
            </Button>
          )}
        </div>
      );
    }
);

const TemplatesPageTitle = ({ showAddButton }: { showAddButton: boolean }) => {
  return (
    <TemplatesPageTitleStyled>
      <Title showAddButton={showAddButton} />
      {/* <SearchTemplateBar /> */}
    </TemplatesPageTitleStyled>
  );
};

export default TemplatesPageTitle;
